import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#7caafb",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.85213 8.12614C9.81996 8.12614 11.4152 6.5309 11.4152 4.56307C11.4152 2.59524 9.81996 1 7.85213 1C5.8843 1 4.28906 2.59524 4.28906 4.56307C4.28906 6.5309 5.8843 8.12614 7.85213 8.12614Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7035 14.0503C13.142 12.9848 12.3002 12.0928 11.269 11.4706C10.2377 10.8484 9.05617 10.5195 7.85176 10.5195C6.64735 10.5195 5.46579 10.8484 4.43455 11.4706C3.40331 12.0928 2.56153 12.9848 2 14.0503C6.4 16.0905 11.6357 14.9004 13.7035 14.0503Z",
			fill: "currentColor",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7035 14.0503C13.142 12.9848 12.3002 12.0928 11.269 11.4706C10.2377 10.8484 9.05617 10.5195 7.85176 10.5195C6.64735 10.5195 5.46579 10.8484 4.43455 11.4706C3.40331 12.0928 2.56153 12.9848 2 14.0503C6.4 16.0905 11.6357 14.9004 13.7035 14.0503Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPersonal;
